import request from '@/api/request'


//PC工作通-战报设置详情
export function reportInfo(data) {
    return request({
        url: '/web/report/get/info',
        method: 'GET',
        params: data
    })
}


//PC工作通-战报列表
export function reportUserList(data) {
    return request({
        url: '/web/report/user/list',
        method: 'GET',
        params: data
    })
}


//PC工作通-战报添加
export function reportUserAdd(data) {
    return request({
        url: '/web/report/user/add',
        method: 'POST',
        data
    })
}
